import {
  Form,
  Input,
  Modal,
  Select,
  Space,
  Button,
  Tooltip,
  message,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  MailOutlined,
  CheckOutlined,
  CloseOutlined,
  MenuOutlined,
  FormOutlined,
  HomeOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import { useLocation } from 'react-router-dom';
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [openApproval, setOpenApproval] = useState(false);
  const [approvedOrRejected, setApprovedOrRejected] = useState('Approved');
  const [approvalForm,] = Form.useForm();
  const [selectedList, setSelectedList] = useState([]);
  const [periodList, setPeriodList] = useState([]);

  const [btnLoading, setBtnLoading] = useState(false);

  const initTableHead = {
    vendorName: null,
    requestNumber: null,
    payAmount: null,
    requestDate: null,
    requestStatus: null,
    jobs: null,
    supervisor: null,
    rejectedReason: null,
    needMaterial: null,
    materialAmount: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    {
      title: '#',
      dataIndex: '#',
      width: 50,
    },
    {
      title: "Vendor",
      dataIndex: "vendorName",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      width: 150,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: "Request Number",
      dataIndex: "requestNumber",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "requestNumber"),
    },
    {
      title: "Pay Amount",
      dataIndex: "payAmount",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, "payAmount"),
    },
    {
      title: "Request Date",
      dataIndex: "requestDate",
      titleType: 'DatePicker',
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'requestDate', 'DatePicker'),
    },
    {
      title: "Request Status",
      dataIndex: "requestStatus",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "requestStatus"),
    },
    {
      title: "Job Type",
      dataIndex: "jobs",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobType"),
      width: 200,
      render: (text) => {
        return (
          <>
            {(text || [])?.map(item => (
               <div>
                { item }
              </div>
            ))}
          </>
        )
      }
    },
    {
      title: 'Supervisor',
      dataIndex: "supervisor",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'supervisor')
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'rejectedReason'),
    },
    {
      title: "Need Material",
      dataIndex: "needMaterial",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "needMaterial"),
    },
    {
      title: "Material $",
      dataIndex: "materialAmount",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, "materialAmount"),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      monthlyWorkerPayId: new URLSearchParams(location.search).get("monthlyWorkerPayId"),
    };
    const response = await http.get(api.checkShowMonthlyWorkerSubDetail, { params });
    // setSelectedList([])
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const getDictionaryFn = async(value) => {
    const response = await http.get(api.getPeriodList);
    setPeriodList((response.data || [])?.map(item => ({
      label: item,
      value: item,
    })))
  }

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
    
  useEffect(() => {
    getDictionaryFn()
  }, [])

  useEffect(() => {
    if(periodList?.length){
      setColumns(initColumns);
    }
  }, [periodList]);


  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

    // 提交数据
  const handleSubmit = async () => {
    setBtnLoading(true)
    const values = await approvalForm.validateFields();
    // 合并数据：表格选中的数据 + 表单数据
    const data = {
      ...values,
      ids: selectedList.map(item => item.vendorPaymentId),
      approvedOrRejected,
      batchGroup: new URLSearchParams(location.search).get("batch"),
    };
    const response = await http.post(api.getCheckApprovalApprove, data);
    if(response.code === '1'){
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setRefreshKey(+new Date())
    }else{
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false)
  };

  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: '1',
      noLimit: 'no'
    });
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
      >
        <div className="topLeft">
          <Space size="small">
            {commonFn.btnAuthorityFlag('Approval') && <Tooltip
              placement="topLeft"
              title="Approval The Requests For Approval From Employee"
            >
              <Button className="btnGreen" style={{marginRight: 0}} onClick={() => approveOrRejectFn('Approved')}>
                <CheckOutlined />
                Approval
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('Reject') && <Tooltip
              placement="topLeft"
              title="Reject The Requests For Approval From Employee"
            >
              <Button className="btnWarning" style={{marginLeft: 0}} onClick={() => approveOrRejectFn('rejected')}>
               <CloseOutlined />
                Reject
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('SelectedAmount') && <Button className="btnGreen" style={{cursor: 'text'}}>Selected Amount:{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(selectedList.map(item => item.amount).reduce((acc, curr) => acc + curr, 0))
            }</Button> || null}
          </Space>
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openApproval}
        maskClosable={false}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to approve these checks?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${approvedOrRejected === 'Approved' ? 'Approve' : 'Reject'} ${selectedList.length} Check(s).`,
                }
              ]}
            />
          </Form.Item>

          {approvedOrRejected === 'Approved' && <Form.Item
            name="noLimit"
            label={<span >Do you want to approve the amount over {<span style={{color:'#a94442',textDecoration:'underline'}}>
              {
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(5000)
              }
            </span>} with signature</span>}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "no",
                  label: "No",
                },
                {
                  value: "yes",
                  label: "Yes",
                },
              ]}
            />
          </Form.Item> || null}

          {approvedOrRejected !== 'Approved' && <Form.Item
            name="rejectedReason"
            label="Rejected Reason"
            style={{ flex: 2 }}
          >
            <Input placeholder="" />
          </Form.Item> || null}
        </Form>
      </Modal>
      
    </div>
  );
});
export default MainTable;
